import { useEffect, useState } from 'react';
import MUITable from '../../../Common/MUITable';
import AddEditDesignations from './AddEditDesignations';
import { TableLoader } from '../../../Common/ShimmerLoader';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import isGHMC from '../../../Common/helper/helpar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GetDesignations, GetActiveDepartments as fetchActiveDepartments } from '../AttendanceApis';
import { ExportDesignation } from './ExportDesignations';
import { StatusBadge } from "../../Rfid/utils/statusBadge";
import { sortActiveFirst } from "../../ComplaintManagement/utils/complaintListUtils";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Designation = () => {
    const isProd = isGHMC();
    const [ShowModal, setShowModal] = useState(false);
    const [editRow, setEditRow] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [activeDepartments, setActiveDepartments] = useState([]);
    const [designations, setDesignations] = useState([]);
    const [filterOriginalDesignationData, setFilterOriginalDesignationData] = useState([]);
    const [isOptionsLoading, setIsOptionsLoading] = useState(false);
    const [searchName, setSearchName] = useState("");
    const [filters, setFilters] = useState({
        IsActive: "",
        designationName: "",
    });

    // let storedPermissions = localStorage.getItem("permissionId");
    // const permissionValues1 =
    //     JSON.parse(localStorage.getItem("rolePermissions")) || {};
    // let canWriteValue = null;

    // storedPermissions = parseInt(storedPermissions, 10);

    // const matchingPermission = permissionValues1.find(
    //     (mapping) => mapping.permissionId === storedPermissions
    // );

    // if (matchingPermission) {
    //     canWriteValue = matchingPermission.canWrite;
    // } else {
    //     console.log(`No match found for permission ID ${storedPermissions}`);
    // }


    // ✅ REPLACE WITH THIS
const permissions = JSON.parse(localStorage.getItem("rolePermissions")) || [];
const canWriteValue = permissions.find(p => p.permissionName === "Designation")?.canWrite ?? false;
// console.log("canWriteValue:", canWriteValue);
// console.log("permissions:", permissions);
    // ✅ FIX 1: Was calling itself recursively — now correctly calls the imported fetchActiveDepartments
    const loadActiveDepartments = async () => {
        setIsOptionsLoading(true);
        try {
            const departmentResponse = await fetchActiveDepartments();
            setActiveDepartments(departmentResponse?.data ?? departmentResponse);
        } catch (error) {
            console.error("Error fetching department data:", error);
        } finally {
            setIsOptionsLoading(false);
        }
    };

    // ✅ FIX 2: Pass designationName filter to API so search actually filters
// ✅ Add search state

const getDesignationsData = async (DesignationName = "") => {
    try {
        const response = await GetDesignations(""); // Load all for table search
        let rows = [];
        if (Array.isArray(response)) {
            rows = response;
        } else if (response?.data) {
            rows = Array.isArray(response.data) ? response.data : [];
        }
        const sortedRows = sortActiveFirst(rows);
        setFilterOriginalDesignationData(sortedRows);
        setDesignations(sortedRows);
    } catch (error) {
        console.error("Error fetching designations:", error);
        setFilterOriginalDesignationData([]);
        setDesignations([]);
    }
};



    useEffect(() => {
        loadActiveDepartments();
        getDesignationsData();
    }, []);

    const handleAdd = () => {
        setIsEditMode(false);
        setEditRow(null);
        setShowModal(true);
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({ ...prev, [name]: value }));
    };

    const handleReset = () => {
        setFilters({ IsActive: "", designationName: "" });
        getDesignationsData();
    };

    const handleEdit = (row) => {
        setShowModal(true);
        setIsEditMode(true);
        setEditRow(row);
    };

    const searchDesignationHandler = (e) => {
        const term = e.target.value.toLowerCase();
        const data = filterOriginalDesignationData.filter(
            (item) =>
                item?.designationName?.toLowerCase()?.includes(term) ||
                item?.departmentName?.toLowerCase()?.includes(term)
        );
        setDesignations(data);
    };

    // Add this temporarily right before the return statement

    

    const designationColumns = [
        {
            label: "Department",
            render: (row) => row.departmentName || "N/A",
        },
        {
            label: "Designation",
            render: (row) => row.designationName || "N/A",
        },
          {
          label: "Status",
          render: (row) => <StatusBadge isActive={row.isActive} compact />,
        },
        {
            label: "Action",
            render: (row) => (
                <button
                    className={`${isProd ? "edit-ghmc" : "edit-swm"}`}
                    onClick={() => handleEdit(row)}
                >
                    <FontAwesomeIcon icon={faEdit} />
                </button>
            ),
        },
    ];

    return (
        <>
            <div className="content text-start">
                <div className="page-content mt-3">

                    {/* ── Header Row ── */}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                            marginBottom: "16px",
                        }}
                    >
                        {/* Left: Title + subtitle */}
                        <div>
                            <h5
                                style={{
                                    fontWeight: 700,
                                    fontSize: "18px",
                                    marginBottom: "4px",
                                    marginTop: "4px",
                                    color: "#1a1a2e",
                                }}
                            >
                                Designation Information
                            </h5>
                           
                        </div>

                        {/* Right: Action buttons */}
                        <div style={{ display: "flex", gap: "10px", alignItems: "center", flexShrink: 0 }}>
                            { (
                                <button className="button-container" onClick={handleAdd}>
                                    <i className="fa-solid fa-plus me-1 icon-container"></i>
                                    Add Designation
                                </button>
                            )}

                        <ExportDesignation designationData={designations} />

                        </div>
                    </div>

                    {/* ── Filter Row ── */}
                    {/* <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            marginBottom: "16px",
                            flexWrap: "wrap",
                            gap: "12px",
                        }}
                    >
                        <div style={{ minWidth: "220px", maxWidth: "300px", flex: "1" }}>
                            <label
                                style={{
                                    fontSize: "13px",
                                    fontWeight: 500,
                                    color: "#344054",
                                    marginBottom: "6px",
                                    display: "block",
                                }}
                            >
                                Search Designation Name
                            </label>
                            <input
                                type="text"
                                name="designationName"
                                value={filters.designationName}
                                onChange={handleFilterChange}
                                placeholder="Enter Designation Name"
                                style={{
                                    width: "100%",
                                    padding: "8px 12px",
                                    border: "1.5px solid #d0d5dd",
                                    borderRadius: "6px",
                                    fontSize: "14px",
                                    color: "#344054",
                                    outline: "none",
                                    backgroundColor: "#fff",
                                }}
                            />
                        </div>

                        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                            <button
                                onClick={() => getDesignationsData(filters.designationName)}
                                style={{
                                    backgroundColor: "var(--btn-primary-bg)",
                                    color: "var(--btn-primary-text)",
                                    border: "none",
                                    borderRadius: "6px",
                                    padding: "9px 20px",
                                    fontWeight: 700,
                                    fontSize: "13px",
                                    cursor: "pointer",
                                    letterSpacing: "0.5px",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                APPLY FILTERS
                            </button>
                            <button
                                onClick={handleReset}
                                style={{
                                    backgroundColor: "#fde8e8",
                                    color: "#e63946",
                                    border: "1.5px solid #f5c6c8",
                                    borderRadius: "6px",
                                    padding: "9px 20px",
                                    fontWeight: 700,
                                    fontSize: "13px",
                                    cursor: "pointer",
                                    letterSpacing: "0.5px",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                RESET
                            </button>
                        </div>
                    </div> */}

                    <div className="row justify-content-between mt-2 mb-2">
                        <div className="col-md-3">
                            <div className="form-group">
                                <input
                                    placeholder="Search Designation or Department"
                                    type="text"
                                    className="form-control bg-white"
                                    onInput={searchDesignationHandler}
                                />
                            </div>
                        </div>
                    </div>

                    {/* ── Table Card ── */}
                    <div className="card shadow mt-2">
                        <div className="card-body">
                            <MUITable
                                needSRNumber={true}
                                rows={designations}
                                columns={designationColumns}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* ✅ FIX 3: Pass activeDepartments (not the empty `operations` array) to the modal */}
            <AddEditDesignations
                showModal={ShowModal}
                setShowModal={setShowModal}
                editRow={editRow}
                isEditMode={isEditMode}
                departmentData={activeDepartments}
                getDesignationsData={getDesignationsData}
            />
            <ToastContainer />
        </>
    );
};

export default Designation;